import React, { useState, useEffect } from 'react';
import InfoIcon from '@svg/info-circle.svg?react';
import Light from '@svg/light.svg?react';
import CustomIcon, { IconType } from '../../../shared/custom-icon/custom-icon';
import './initial-alert.scss';

interface InitialAlertProps {
    connectionsCount: number;
}

const LOCAL_STORAGE_KEY = 'ecmInitialAlertDismissed';

const InitialAlert: React.FC<InitialAlertProps> = ({ connectionsCount }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const dismissed = localStorage.getItem(LOCAL_STORAGE_KEY);
        setVisible(!dismissed);
    }, []);

    const handleClose = () => {
        localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
        setVisible(false);
    };

    if (!visible || connectionsCount === 0) return null;

    return (
        <div className="initial-alert">
            <div className="initial-alert-content">
                <InfoIcon className="info-icon-alert"/>
                <div className="alert-title">
                    There {connectionsCount === 1 ? 'is' : 'are'} {connectionsCount} connection{connectionsCount === 1 ? '' : 's'} with AT&T Initial policy applied.
                </div>
                <Light className="light-icon-alert"/>
                <div className="alert-subtitle">
                    Tip: Apply a policy you have created to other connections with the “New policy” option.
                </div>
            </div>
            <button type="button" className="close-btn" onClick={handleClose} aria-label="Dismiss Alert">
                <CustomIcon type={IconType.X} size={9}/>
            </button>
        </div>
    );
};

export default InitialAlert;
